import { motion } from 'framer-motion';
import { subscriptionPlans } from '../../data/landingData';
import { fadeInUp, staggerContainer } from '../../utils/motion';
import { Button } from '../ui/Button';
import { SectionTitle } from '../ui/SectionTitle';

export function PricingSection() {
  return (
    <section id="licencias" className="bg-canvas py-16 sm:py-20">
      <div className="container-base">
        <SectionTitle
          title="Licencias pensadas para profesionales e instituciones"
          subtitle="Comparativa mensual y anual con funcionalidades listas para implementar desde el día uno."
          centered
        />

        <motion.div
          className="mt-10 grid gap-5 lg:grid-cols-2"
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {subscriptionPlans.map((plan) => {
            const Icon = plan.icon;
            return (
              <motion.article
                key={plan.name}
                variants={fadeInUp}
                whileHover={{ y: -4 }}
                className={`rounded-3xl border p-6 shadow-soft transition-colors sm:p-8 ${
                  plan.highlighted
                    ? 'border-brand-500 bg-brand-500 text-white'
                    : 'border-slate-200 bg-white text-ink'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Icon className={`h-5 w-5 ${plan.highlighted ? 'text-blue-100' : 'text-brand-500'}`} />
                  <h3 className="font-display text-xl font-semibold">{plan.name}</h3>
                </div>
                <p className={`mt-3 text-sm leading-relaxed ${plan.highlighted ? 'text-blue-50' : 'text-slate-600'}`}>
                  {plan.description}
                </p>

                <div className="mt-6 grid grid-cols-2 gap-3">
                  <div className={`rounded-2xl p-3 ${plan.highlighted ? 'bg-brand-600' : 'bg-canvas'}`}>
                    <p className={`text-xs ${plan.highlighted ? 'text-blue-100' : 'text-slate-500'}`}>Mensual</p>
                    <p className="mt-1 font-display text-xl font-bold">{plan.monthlyPrice}</p>
                  </div>
                  <div className={`rounded-2xl p-3 ${plan.highlighted ? 'bg-brand-600' : 'bg-canvas'}`}>
                    <p className={`text-xs ${plan.highlighted ? 'text-blue-100' : 'text-slate-500'}`}>Anual</p>
                    <p className="mt-1 font-display text-xl font-bold">{plan.annualPrice}</p>
                  </div>
                </div>

                <ul className="mt-5 space-y-2 text-sm">
                  {plan.bullets.map((bullet) => (
                    <li key={bullet} className="flex gap-2">
                      <span className={`mt-1 h-1.5 w-1.5 rounded-full ${plan.highlighted ? 'bg-white' : 'bg-brand-500'}`} />
                      {bullet}
                    </li>
                  ))}
                </ul>

                {plan.name === 'Instituciones' ? (
                  <Button
                    href="https://wa.link/f0mwlc"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant={plan.highlighted ? 'light' : 'primary'}
                    className="mt-6 w-full sm:w-auto"
                  >
                    Más información
                  </Button>
                ) : null}
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
